/* Libraries */
import React from 'react';
import { inject, observer } from 'mobx-react';

/* Higher Order Components */
import WithLayoutProps from '~/src/hoc/WithLayoutProps';

/* Components */
import SettingsOrganization from '~/src/components/Settings/SettingsOrganization';

/* Constants */
import { LAYOUT_MODAL_TYPES } from '~/src/components/PageLayout/Modals';
import { LAYOUT_TOAST_TYPES } from '~/src/components/PageLayout/Toasts';

class SettingsOrganizationContainer extends React.Component {
  state = {
    updates: {},
  };

  addUpdate = (field, value) => {
    this.setState((prev) => ({
      updates: { ...prev.updates, [field]: value },
    }));
  };

  handleSetAsDefault = () => {
    const handleConfirm = () => {
      this.props.store.user.currentOrganization.setAsDefault();
      const orgName =
        this.props.store.user.currentOrganization.organizationName;
      this.props.showToast(LAYOUT_TOAST_TYPES.success, {
        message: `${orgName} set as default orgnaization`,
      });
      this.props.hideModal();
    };

    const orgName = this.props.store.user.currentOrganization.organizationName;

    this.props.showModal(LAYOUT_MODAL_TYPES.confirm, {
      title: `Set as default organization`,
      message: `You are about to set ${orgName} as your default organization.`,
      onConfirm: handleConfirm,
      primaryActionTitle: 'Set default',
    });
  };

  handleNameChange = (value) => {
    this.addUpdate('organizationName', value);
  };

  handlePrimaryPracticeAreaChange = (value) => {
    this.addUpdate('primaryPracticeArea', value);
  };

  handleSecondaryPracticeAreaChange = (value) => {
    this.addUpdate('secondaryPracticeArea', value);
  };

  handlePrimaryStateChange = (value) => {
    this.addUpdate('primaryState', value);
  };

  handleSubmit = async () => {
    const { updates } = this.state;

    if (Object.keys(updates).length === 0) {
      return;
    }

    const { currentOrganization } = this.props.store.user;
    const success = await currentOrganization.update(updates);

    if (success) {
      this.props.showToast(LAYOUT_TOAST_TYPES.success, {
        message: 'Organization settings updated!',
      });
      this.setState({ updates: {} });
    } else {
      this.props.showToast(LAYOUT_TOAST_TYPES.error, {
        message:
          'Failed to update organization settings, please try again later.',
      });
    }
  };

  render() {
    const { currentOrganization } = this.props.store.user;
    const showSetAsDefault = this.props.store.user.organizations.length > 1;
    const isAdmin = currentOrganization.admin;

    return (
      <SettingsOrganization
        onSave={this.handleSubmit}
        showSetAsDefault={showSetAsDefault}
        isDefault={currentOrganization.isDefault}
        currentOrganizationName={currentOrganization.organizationName}
        currentPrimaryPracticeArea={currentOrganization.primaryPracticeArea}
        currentSecondaryPracticeArea={currentOrganization.secondaryPracticeArea}
        currentPrimaryState={currentOrganization.primaryState}
        onChange={this.handleNameChange}
        onPrimaryPracticeAreaChange={this.handlePrimaryPracticeAreaChange}
        onSecondaryPracticeAreaChange={this.handleSecondaryPracticeAreaChange}
        onPrimaryStateChange={this.handlePrimaryStateChange}
        onSetAsDefault={this.handleSetAsDefault}
        isAdmin={isAdmin}
      />
    );
  }
}

export default inject((store) => store)(
  WithLayoutProps(observer(SettingsOrganizationContainer)),
);
